class FullscreenVideo {
	private readonly onOpen: () => void
	private readonly onClose: () => void
	private readonly el: HTMLElement
	private readonly btnNode: HTMLElement
	private readonly closeNode: HTMLElement
	private readonly videoNode: HTMLVideoElement

	constructor(el, onOpen, onClose) {
		this.showFullScreen = this.showFullScreen.bind(this)
		this.hideFullScreen = this.hideFullScreen.bind(this)

		this.el = el
		this.onOpen = onOpen
		this.onClose = onClose
		this.btnNode = el.querySelector('.js-video-full-btn')
		this.closeNode = el.querySelector('.js-video-full-close')
		this.videoNode = el.querySelector('video')

		this.videoNode.addEventListener('webkitendfullscreen', this.hideFullScreen)
		this.btnNode.addEventListener('click', this.showFullScreen)
		this.closeNode.addEventListener('click', this.hideFullScreen)
	}

	show() {
		this.el.classList.add('is-visible')
	}

	hide() {
		this.hideFullScreen()
		this.el.classList.remove('is-visible')
	}

	showFullScreen() {
		this.onOpen()
		this.btnNode.classList.add('is-hidden')
		this.closeNode.classList.add('is-visible')
		this.videoNode.classList.add('is-visible')

		if (this.videoNode.readyState >= this.videoNode.HAVE_METADATA) {
			this.videoNode.currentTime = 0
			this.videoNode.play()
		}
	}

	hideFullScreen() {
		this.btnNode.classList.remove('is-hidden')
		this.closeNode.classList.remove('is-visible')
		this.videoNode.classList.remove('is-visible')
		this.videoNode.pause()
		this.onClose()
	}
}

export default FullscreenVideo
